import PropTypes from "prop-types";
import React from "react";
import { hideToast } from "actions/toastActions";
import { Toast as ToastNotification } from "cxa-components";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

const Toast = ({ intl, hideToast, id, message, ...props }) =>
  <ToastNotification
    {...props}
    message={intl.formatMessage({ id: message, defaultMessage: message })}
    key={id}
    onDismiss={hideToast}
    onClick={hideToast}
  />;

const mapStateToProps = ({ toast }) => ({
  ...toast,
});

const mapDispatchToProps = {
  hideToast,
};

Toast.propTypes = {
  intl: PropTypes.object,
  hideToast: PropTypes.func,
  id: PropTypes.string,
  message: PropTypes.string,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Toast));



// WEBPACK FOOTER //
// ./components/common/Toast.js